const protocolAndDomain = /^(?:\w+:)?\/\/(\S+)$/
const nonLocalhostDomain = /^[^\s.]+\.\S{2,}$/
const protocol = /^https?:\/\//

module.exports = function() {
  return value => {
    if (typeof value !== 'string') {
      return false
    }

    const match = value.match(protocolAndDomain)
    if (!match) {
      return false
    }

    if (!protocol.test(match[0])) {
      return false
    }

    const everythingAfterProtocol = match[1]
    if (!everythingAfterProtocol) {
      return false
    }

    if (nonLocalhostDomain.test(everythingAfterProtocol)) {
      return true
    }

    return false
  }
}
